import React, { useEffect } from 'react';
import AppRoute from 'routes';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { connect } from 'react-redux';
import AttributesProvider from 'context/propertyAttributes';

import DetectNetwork from 'common/components/detectNetwork';
import { initializeGA, pageViews } from 'common/utils/googleAnalytics';
import WebSocketProvider from 'context/publishStatus';

import 'react-toastify/dist/ReactToastify.css';

// import 'primereact/resources/themes/saga-blue/theme.css';
//import 'primereact/resources/primereact.min.css';

// importing primereact theme css manually by creating theme files and pasting the content of library css into it
// This is done to prevent breaking css changes introduced by @layer in primereact v10.0.0
import 'static/primereact.min.css';
import 'static/primereacttheme.css';
import 'primeicons/primeicons.css';

// vendor styles should be above this
import 'static/scss/main.scss';

// Create a client
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 20,
    },
  },
});

function App({ userDetail }) {
  useEffect(() => {
    initializeGA();
  }, []);

  // Detect pageview on app mount when there is user detail available
  useEffect(() => {
    if (userDetail) {
      pageViews();
    }
  }, [userDetail]);

  return (
    <DetectNetwork>
      <QueryClientProvider client={queryClient}>
        {/* <AttributesProvider> */}
          <WebSocketProvider>
            <AppRoute />
          </WebSocketProvider>
        {/* </AttributesProvider> */}
      </QueryClientProvider>
    </DetectNetwork>
  );
}

const mapStateToProps = state => {
  const { userDetail } = state.loginReducer;

  return { userDetail };
};

export default connect(mapStateToProps)(App);
